<template>
  <div style="width: 100%;">
    <el-header style="margin: 15px" >
      <breadcrumb></breadcrumb>
    </el-header> 

    <el-main  v-loading.fullscreen.lock="loading">
      <el-form ref="form" label-width="180px" >        
          <el-row>  
            <el-col :span="12">
              <h3>{{$t('field.custBasicInfomation')}}</h3>
            </el-col>  
            <el-col :span="12" style="text-align:right;padding-bottom:10px">
              <el-button type="primary" @click="copyFromSAP"  size="small">{{$t('button.copyFromSAP')}}</el-button>      
              <el-button type="warning" @click="save"  size="small">{{$t('button.save')}}</el-button>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
                <el-form-item :label="$t('field.customerNo')">
                  <el-input v-model="form.sapCode" :disabled="true"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$t('field.source')">
                  <el-input v-model="form.source" :disabled="true"></el-input>    
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$t('field.rmaShortCode')" label-width="200px">
                  <el-input v-model="form.rmaShortCode" maxlength=3></el-input>    
                </el-form-item>
              </el-col>             
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item :label="$t('field.bukrs')">
                <el-input v-model="form.bukrs" maxlength=100></el-input>    
              </el-form-item>
            </el-col>   
            <el-col :span="8">
              <el-form-item :label="$t('field.area')">  
                <el-select v-model="form.area" :placeholder="$t('msg.pleaseSelect')">
                  <el-option v-for="item in areaOptions"  :key="item.value"  :label="item.label" :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('field.country')" label-width="200px">             
                <el-select v-model="form.country" :placeholder="$t('msg.pleaseSelect')" style="width:100%" :no-data-text="$t('msg.noDataFound')" >
                  <el-option v-for="item in countryOpts"  :key="item.value"  :label="item.label" :value="item.value"></el-option>
                </el-select> 
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>            
            <el-col :span="8">
              <el-form-item :label="$t('field.bzirk')">
                <el-input v-model="form.bzirk" maxlength=255></el-input>    
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('field.customerGroup')">
                <el-input v-model="form.konzs" maxlength=100></el-input>    
              </el-form-item>
            </el-col>   
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item :label="$t('field.sortl')">
                <el-input v-model="form.sortl" maxlength=500></el-input>    
              </el-form-item>
            </el-col> 
            <el-col :span="12">
              <el-form-item :label="$t('field.companyPhone')">
                <el-input v-model="form.telf1" maxlength=100></el-input>    
              </el-form-item>
            </el-col>          
          </el-row>    
          <el-form-item :label="$t('field.customerNameE')">
            <el-input v-model="form.customerNameE" maxlength=1000></el-input>    
          </el-form-item>

          <el-form-item :label="$t('field.customerNameC')">
            <el-input v-model="form.customerNameC" maxlength=1000></el-input>    
          </el-form-item>

          <el-form-item :label="$t('field.companyAddress')">
            <el-input v-model="form.address" maxlength=500></el-input>    
          </el-form-item> 

          <el-form-item :label="$t('field.onlyApplicant')">
          <el-checkbox v-model="form.onlyApplicantChk"></el-checkbox>
          </el-form-item> 
          
          <el-row>
            <el-col :span="24">
              <CustomerWindows  ref="customerWindows" :custId="form.id"  />
            </el-col>
          </el-row>      
          <h3>{{$t('field.custInnoCareContactWindow')}}</h3>   
          <el-row>
            <el-col :span="15">
              <IncxWindows ref="incxWindows" :custId="form.id"/>
            </el-col>
          </el-row> 
          <h3>{{$t('field.custRMAInformation')}}</h3>
          <el-row>
            <el-col :span="24">
              <RmaInfo ref="rmaInfo" :custId="form.id"/>
            </el-col>
          </el-row> 
          <h3>{{$t('field.productInformation')}}</h3>
          <el-row>
            <el-col :span="20">
              <ProductInfo ref="productInfo"  :custId="form.id"/>
            </el-col>
          </el-row>
          <h3>{{$t('field.moreInformation')}}</h3>
          <el-row>
            <el-col :span="20">
              <MoreInfo ref="moreInfo" :custId="form.id"/>
            </el-col>
          </el-row>
        </el-form>
        <el-dialog ref="copyFromSapDialog" :title="$t('field.CopyCustfromSAP')" :visible.sync="dialogVisible" width="50%" :before-close="handleClose">
          <el-form :model="copyFromSapForm"  label-width="195px">
            <el-form-item :label="$t('msg.fuzzySearch')" >
              <SapCustomerSearch ref="searchSapCustomer"  @sync-select-customer-code="syncSelectCustomerCode" />
            </el-form-item>
            <h4>* {{$t('field.checkFollowingFieldCopy')}} </h4>    
            <div style="padding-left:20px">
              <el-checkbox v-model="checkAll" @change="checkAllChange">{{$t('field.checkAll')}}</el-checkbox>
            </div>
            <el-row :gutter="10">
              <el-col :span="20">
                <el-form-item :label="$t('field.customerNo')" >
                  <el-input v-model="copyFromSapForm.sapCode" :disabled="true" ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :span="20">
                <el-form-item :label="$t('field.country')" >
                  <el-input v-model="copyFromSapForm.country" :disabled="true" ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="3">
                <el-checkbox v-model="countryChk"></el-checkbox>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :span="20">
                <el-form-item :label="$t('field.sortl')">
                  <el-input v-model="copyFromSapForm.sortl" :disabled="true" ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-checkbox v-model="sortlChk"></el-checkbox>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :span="20">
                <el-form-item :label="$t('field.bzirk')" >
                  <el-input v-model="copyFromSapForm.bzirk" :disabled="true" ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="3">
                <el-checkbox v-model="bzirkChk"></el-checkbox>
              </el-col>
            </el-row>           
            <el-row :gutter="10">
              <el-col :span="20">
                <el-form-item :label="$t('field.customerNameC')" >
                  <el-input v-model="copyFromSapForm.customerNameC" :disabled="true" ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="3">
                <el-checkbox v-model="customerNameCChk"></el-checkbox>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :span="20">
                <el-form-item :label="$t('field.customerNameE')">
                  <el-input v-model="copyFromSapForm.customerNameE" :disabled="true" ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="3">
                <el-checkbox v-model="customerNameEChk"></el-checkbox>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :span="20">
                <el-form-item :label="$t('field.companyAddress')">
                  <el-input v-model="copyFromSapForm.address" :disabled="true" ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="3">
                <el-checkbox v-model="addressChk"></el-checkbox>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :span="20">
                <el-form-item :label="$t('field.purPerson')">
                  <el-input v-model="copyFromSapForm.purPerson" :disabled="true" ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="3">
                <el-checkbox v-model="purPersonChk"></el-checkbox>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :span="20">
                <el-form-item :label="$t('field.purPersonMail')">
                  <el-input v-model="copyFromSapForm.purPersonMail" :disabled="true" ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :span="20">
                <el-form-item :label="$t('field.purPersonTel')">
                  <el-input v-model="copyFromSapForm.purPersonTel" :disabled="true" ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <span slot="footer" class="dialog-footer">
              <el-button @click="dialogVisible = false">{{$t('button.cancel')}}</el-button>
              <el-button type="warning" @click="confirmFromSap">{{$t('button.confirm')}}</el-button>
          </span>
        </el-dialog>
    </el-main>
  </div>
</template>

<script>
import Breadcrumb from '../components/Breadcrumb'
import CustomerWindows from '../components/customerManage/CustomerWindows'
import IncxWindows from '../components/customerManage/IncxWindows'
import RmaInfo from '../components/customerManage/RmaInfo'
import ProductInfo from '../components/customerManage/ProductInfo'
import MoreInfo from '../components/customerManage/MoreInfo'
import SapCustomerSearch from '../components/SapCustomerSearch'
import { apiFindCustById, apiFindSysValueByCategory, apiFindSysAttrValueByCategory, apiSaveCust } from "../../utils/api.js";
import authHeader from "../../services/auth-header";


export default {
  name: 'editCustomer',
  data() {   
    return {    
      checked:false,
      loading:false,
      dialogVisible: false,
      form:{
        id: '',
        sapCode: '',
        source: '',
        area: '',
        country: '',
        rmaShortCode: '',
        sortl: '',
        bzirk: '',
        customerNameE: '',
        customerNameC: '',
        address: '',
        telf1: '',
        konzs: '',
        bukrs: '',
        modifyUser: '',
        modifyTime: '', 
        onlyApplicantChk: ''
      },
      areaOptions: [],
      custWindows:[],
      countryOpts:[],
      countryChk:false,
      checkAll:false,
      sortlChk:false,
      bzirkChk:false,
      customerNameCChk:false,
      customerNameEChk:false,
      addressChk:false,
      purPersonChk:false,
      copyFromSapForm: {         
        sapCode:'',
        country:'',
        sortl:'',
        bzirk:'',
        customerNameC:'',
        customerNameE:'',
        address:'',
        purPerson:'',
        purPersonMail:'',
        purPersonTel:'',
        konzs:'',
        bukrs:''  
      },     
    };
  },   
  components: {
    Breadcrumb,
    CustomerWindows,
    IncxWindows,
    RmaInfo,
    ProductInfo,
    MoreInfo,
    SapCustomerSearch 
  },
  created(){ 
    this.form.id = this.$route.params.id;
    if(this.form.id == null){
      console.log("create");
    }else {
      console.log("modify:"+this.form.id );
    }
  },
  mounted() {
    apiFindSysValueByCategory({ headers: authHeader(), condition: 'area'}).then((response) => { 
      response.data.forEach((item, index) => {                  
        this.areaOptions.push({ value: item.value });          
      });
    }).catch((err) => {
      console.log(err);
    });
    apiFindSysAttrValueByCategory({ headers: authHeader(), condition: 'COUNTRY'}).then((response) => { 
      this.countryOpts = [];
      response.data.forEach((item, index) => {   
        this.countryOpts.push({ value: item.key, label: item.key +' '+ item.value });
      });
    }).catch((err) => {
      console.log(err);
    });
    if(this.form.id != null && this.form.id != ''){
      
      apiFindCustById({ headers: authHeader(), condition:this.form.id}).then((response) => { 
        response.data.onlyApplicantChk = (response.data.onlyApplicantChk == 1 ? true:false);
        this.form = response.data;      
      }).catch((err) => {
        console.log(err);
      });   
    }
  },
  watch:{   
    countryChk: function(){      
      if(!this.countryChk){
        let tmpChkAll =  this.checkAll;        
        this.checkAll = false;
        if(tmpChkAll){ //再將其他勾選回來       
          this.sortlChk = true;
          this.bzirkChk = true;
          this.customerNameCChk = true;
          this.customerNameEChk = true;
          this.addressChk = true;
          this.purPersonChk = true;
        }
      }
    },
    sortlChk: function(){
      if(!this.sortlChk){
        let tmpChkAll =  this.checkAll;  
        this.checkAll = false;      
        if(tmpChkAll){ //再將其他勾選回來       
          this.countryChk = true;
          this.bzirkChk = true;
          this.customerNameCChk = true;
          this.customerNameEChk = true;
          this.addressChk = true;
          this.purPersonChk = true;
        }
      }
    },
    bzirkChk: function(){
      if(!this.bzirkChk){
        let tmpChkAll =  this.checkAll; 
        this.checkAll = false;
    
        if(tmpChkAll){ //再將其他勾選回來       
          this.countryChk = true;
          this.sortlChk = true;         
          this.customerNameCChk = true;
          this.customerNameEChk = true;
          this.addressChk = true;
          this.purPersonChk = true;
        }
      }
    },
    customerNameCChk: function(){
      if(!this.customerNameCChk){
        let tmpChkAll =  this.checkAll; 
        this.checkAll = false;
        if(tmpChkAll){ //再將其他勾選回來       
          this.countryChk = true;
          this.sortlChk = true;
          this.bzirkChk = true;
          this.customerNameEChk = true;
          this.addressChk = true;
          this.purPersonChk = true;
        }
      }
    },
    customerNameEChk: function(){
      if(!this.customerNameEChk){
        let tmpChkAll =  this.checkAll; 
        this.checkAll = false;
        if(tmpChkAll){ //再將其他勾選回來       
          this.countryChk = true;
          this.sortlChk = true;
          this.bzirkChk = true;
          this.customerNameCChk = true;
          this.addressChk = true;
          this.purPersonChk = true;
        }
      }
    },
    addressChk: function(){
      if(!this.addressChk){
        let tmpChkAll =  this.checkAll; 
        this.checkAll = false;
        if(tmpChkAll){ //再將其他勾選回來       
          this.countryChk = true;
          this.sortlChk = true;
          this.bzirkChk = true;
          this.customerNameCChk = true;
          this.customerNameEChk = true;
          this.purPersonChk = true;
        }
      }
    },
    purPersonChk: function(){
      if(!this.purPersonChk){
        let tmpChkAll =  this.checkAll; 
        this.checkAll = false;
        if(tmpChkAll){ //再將其他勾選回來       
          this.countryChk = true;
          this.sortlChk = true;
          this.bzirkChk = true;
          this.customerNameCChk = true;
          this.customerNameEChk = true;
          this.addressChk = true;
        }
      }
    }

  },
  methods: {
    checkAllChange(){
      if(this.checkAll){
        this.countryChk = true;
        this.sortlChk = true;
        this.bzirkChk = true;
        this.customerNameCChk = true;
        this.customerNameEChk = true;
        this.addressChk = true;
        this.purPersonChk = true;
      }else{        
        this.countryChk = false;
        this.sortlChk = false;
        this.bzirkChk = false;
        this.customerNameCChk = false;
        this.customerNameEChk = false;
        this.addressChk = false;
        this.purPersonChk = false;
      }
    },
    copyFromSAP() {
      this.checkAll=false;
      this.countryChk=false;
      this.sortlChk=false;
      this.bzirkChk=false;
      this.customerNameCChk=false;
      this.customerNameEChk=false;
      this.addressChk=false;
      this.purPersonChk=false;

      this.copyFromSapForm.sapCode='';
      this.copyFromSapForm.country='';    
      this.copyFromSapForm.sortl='';  
      this.copyFromSapForm.bzirk='';   
      this.copyFromSapForm.customerNameC='';
      this.copyFromSapForm.customerNameE='';
      this.copyFromSapForm.address='';   
      this.copyFromSapForm.purPerson='';
      this.copyFromSapForm.purPersonMail='';
      this.copyFromSapForm.purPersonTel='';
      this.copyFromSapForm.konzs='';
      this.copyFromSapForm.bukrs='';   
      if(this.$refs.searchSapCustomer != null){
        this.$refs.searchSapCustomer.selectCustomer = '';
      } 
      
      this.dialogVisible = true;   
    },    
    chkWarrantyFormat(warranty){
      
      if(warranty.indexOf('yr') > -1){
        let num = Number(warranty.replace('yr',''));
        var a = isNaN(num);        
        return !isNaN(num);
        
      }else if(warranty.indexOf('M') > -1){
        let num = Number(warranty.replace('M',''));
        var a = isNaN(num);        
        return !isNaN(num);
      }else{
        return false;
      }
    },
    save() {   
      var productInfo = this.$refs.productInfo;
      var moreInfo = this.$refs.moreInfo;
      var rmaInfo = this.$refs.rmaInfo;
      var incxWindows = this.$refs.incxWindows;
      var moreInfo = this.$refs.moreInfo;
   
      let check = true;
      //檢查Warranty表格warranty和limitDesc　是否有符合xyr / xM
      this.$refs.rmaInfo.tableData.data.forEach((item) => {
        if(check){
          if(item.warranty != null && item.warranty != ''){
            check = this.chkWarrantyFormat(item.warranty )
          }else if(item.limitDesc != null && item.limitDesc != ''){
            check = this.chkWarrantyFormat(item.limitDesc )
        }
        }else{
          this.$message({ type: "error", message: this.$i18n.t('msg.checkWarrantyFormat'), duration: 2000});
          return false;
        }        
      });
  
      if(check){
        this.form.onlyApplicantChk = (this.form.onlyApplicantChk==true ? 1 : 0);
        this.loading = true;
        apiSaveCust({ 
          headers: authHeader(), 
          cust: this.form,
          custIncxWindows:this.$refs.incxWindows.tableData.data,
          custWindows:this.$refs.customerWindows.tableData.data,
          custRma:this.$refs.rmaInfo.rmaform,
          custWarranty:this.$refs.rmaInfo.tableData.data,
          productMap: {
            'DETECTOR_INNOCARE_MODEL':this.$refs.productInfo.detector.selectedLlist1,
            'DETECTOR_ODM_MODEL':this.$refs.productInfo.detector.selectedLlist2,
            'ACCESSORY_INNOCARE_MODEL':this.$refs.productInfo.accessory.selectedLlist1,
            'ACCESSORY_ODM_MODEL':this.$refs.productInfo.accessory.selectedLlist2,
            'SOFTWARE_INNOCARE':this.$refs.productInfo.software.selectedLlist1,
            'SOFTWARE_ODM':this.$refs.productInfo.software.selectedLlist2,
            'SEMI_CUSTOMER_MODEL':this.$refs.productInfo.semi.selectedLlist1,
            'SEMI_INCX_MODEL':this.$refs.productInfo.semi.selectedLlist2,
            'DOCUMENT_AUTH':this.$refs.productInfo.document.selectedLlist1,
            'MORE_INNOCARE':this.$refs.moreInfo.more.selectedLlist1,
            'MORE_OEM':this.$refs.moreInfo.more.selectedLlist2,
            
          }
          }).then((response) => { 
            if(response.data){
            
              this.form = response.data.cust;
              this.$router.push("/editCustomer/" +  response.data.cust.id);
              this.$refs.incxWindows.tableData.data =  response.data.custIncxWindows;
              this.$refs.customerWindows.tableData.data =  response.data.custWindows;
              this.$refs.rmaInfo.rmaform = response.data.custRma;
              this.$refs.rmaInfo.tableData.data= response.data.custWarranty;
              this.loading = false;

              this.$message({ type: "success", message: this.$i18n.t('msg.saveSuccess'), duration: 800});
              setTimeout(( () => location.reload()), 900);
            }else{
              this.loading = false;
              this.$message({ type: "error", message: this.$i18n.t('msg.saveFail'), duration: 800});
            }
          
        }).catch((err) => {      
          if(err.response != null && err.response.data != null && err.response.data.message != null){
            console.log(err.response.data.message);
            this.loading = false;
            this.$message({ type: "error", message: err.response.data.message, duration: 1000});
          }else{
            this.loading = false;
            this.$message({ type: "error", message: this.$i18n.t('msg.saveFail'), duration: 1000});
          }          
        });
      }
      
      
    },
    handleClose(done) {
      this.$confirm(this.$i18n.t('msg.confirmtoClose'),{
          confirmButtonText: this.$i18n.t('button.confirm'),
          cancelButtonText: this.$i18n.t('button.cancel'),
          type: 'warning'
        })
        .then(_ => {
          this.dialogVisible = false;
          done();
        })
        .catch(_ => {});
    },
    confirmFromSap(){
      const confirmText = ['確定要複製以下內容？'];
      let chk = false;
      if(this.countryChk){
        confirmText.push(this.$i18n.t('field.country')+'：'+this.copyFromSapForm.country);
        chk = true;
      }

      if(this.sortlChk){
        confirmText.push(this.$i18n.t('field.sortl')+'：'+this.copyFromSapForm.sortl);
        chk = true;
      }

      if(this.bzirkChk){
        confirmText.push(this.$i18n.t('field.bzirk')+'：'+this.copyFromSapForm.bzirk);
        chk = true;
      }

      if(this.customerNameCChk){
        confirmText.push(this.$i18n.t('field.customerNameC')+'：'+this.copyFromSapForm.customerNameC);
        chk = true;
      }

      if(this.customerNameEChk){
        confirmText.push(this.$i18n.t('field.customerNameE')+'：'+this.copyFromSapForm.customerNameE);
        chk = true;
      }

      if(this.addressChk){
        confirmText.push(this.$i18n.t('field.companyAddress')+'：'+this.copyFromSapForm.address);
        chk = true;
      }

      if(this.purPersonChk){
        confirmText.push(this.$i18n.t('field.purPerson')+'：'+this.copyFromSapForm.purPerson);
        chk = true;
      }
      if(!chk){
        return this.$message.warning({message: this.$i18n.t('msg.selectDataFirst'), duration: 800});
      }else{
        const newDatas = []
        const h = this.$createElement;
        for (const i in confirmText) {
          newDatas.push(h('p', null, confirmText[i]))
        }

        this.$confirm('',{
          message: h('div', null, newDatas),
          confirmButtonText: this.$i18n.t('button.confirm'),
          cancelButtonText: this.$i18n.t('button.cancel'),
          type: 'warning'
        })
        .then(_ => {
          var copy = false;
          if(this.countryChk){
            this.form.country = this.copyFromSapForm.country;
            copy = true;
          }

          if(this.sortlChk){
            this.form.sortl = this.copyFromSapForm.sortl;
            copy = true;
          }

          if(this.bzirkChk){
            this.form.bzirk = this.copyFromSapForm.bzirk;
            copy = true;
          }

          if(this.customerNameCChk){
            this.form.customerNameC = this.copyFromSapForm.customerNameC;
            copy = true;
          }

          if(this.customerNameEChk){
            this.form.customerNameE = this.copyFromSapForm.customerNameE;
            copy = true;
          }
          if(this.addressChk){
            this.form.address = this.copyFromSapForm.address;
            copy = true;
          }
          if(this.purPersonChk){
            this.$refs.customerWindows.tableData.data.splice(0, 0, {
              cust_id: this.form.id,
              name: this.copyFromSapForm.purPerson,
              phone: this.copyFromSapForm.purPersonTel,
              email: this.copyFromSapForm.purPersonMail
            });
          
            copy = true;
          }

          if(copy){
            this.form.sapCode = this.copyFromSapForm.sapCode;
            this.form.konzs = this.copyFromSapForm.konzs;
            this.form.bukrs = this.copyFromSapForm.bukrs;
            this.form.source = 'SAP';
          }
          this.dialogVisible = false;
          done();
        })
        .catch(_ => {});
      }
      

      
    },
    syncSelectCustomerCode(selectedData){
      this.copyFromSapForm = selectedData;
    },


    
  }
};
</script>

<style>

  .el-message-box {
    width: 500px;
  }
</style>